export default "__VITE_ASSET__2d7586f5__"